import InvoiceGenerateForm from 'widgets/Invoices/InvoiceGenerateForm';
import { Breadcrumb } from 'flowbite-react';

const PageCreateInvoice = () => {
  return (
    <div className="mx-auto mb-40 max-w-7xl px-4 sm:px-6 md:px-8">
      <Breadcrumb className="mb-6">
        <Breadcrumb.Item href="/dashboard/invoices">
          <span className="text-slate-500 font-normal">Invoices</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span className="text-slate-500 font-normal">Create Invoice</span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <InvoiceGenerateForm />
    </div>
  );
};

export default PageCreateInvoice;
